import { useState } from "react";

const KEY = "tt-calm";
export const isCalm = () => localStorage.getItem(KEY) === "1";
export const applyCalm = () => document.documentElement.classList.toggle("calm", isCalm());

// Settings: calm mode stills motion across the Temple (animations, smooth scrolling, moving light).
export function CalmToggle() {
  const [on, setOn] = useState(isCalm);
  const toggle = () => {
    localStorage.setItem(KEY, on ? "0" : "1");
    setOn(!on);
    applyCalm();
    window.dispatchEvent(new Event("tt-calm"));
  };
  return (
    <section data-testid="calm-toggle" className="mt-6 flex items-center justify-between gap-4 border border-[#D9B47A]/20 p-5">
      <span><span className="block font-display text-xl">Calm mode</span><span className="block text-sm text-[#A8998C]">Reduces motion and animation everywhere</span></span>
      <button data-testid="calm-toggle-switch" role="switch" aria-checked={on} onClick={toggle} className={`relative w-12 h-7 shrink-0 rounded-full transition-colors ${on ? "bg-[#D9B47A]" : "bg-[#3a2a1c]"}`}>
        <span className={`absolute top-1 w-5 h-5 rounded-full bg-[#0A0706] transition-transform ${on ? "translate-x-6" : "translate-x-1"}`} />
      </button>
    </section>
  );
}
